export default {
  faqPage: {},
  faq: [],
};
